<template>
  <div class="m-order-summary">
    <payment-information :summary="summary" :show-shipping-delta="showShippingDelta" />
    <div v-if="includesNonrefundableItems" class="text-small mt-4">
      <span>{{ $t('orderIncludesOrderingItems', 'orderIncludesOrderingItems') }}</span
      ><br />
      <span>{{ $t('orderingItemsCannotBeReturned', 'orderingItemsCannotBeReturned') }}</span>
      <base-link :link="termsAndConditionsPage.url">
        {{ termsAndConditionsPage.name }}
      </base-link>
    </div>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px">
      <slot v-if="$isNotNullOrUndefined(orderlines)" name="button">
        <base-button class="a-button -outline-dark semibold p-4 px-0" @click="printPdf()">
          {{ $t('printBasket', 'Print din indkøbskurv') }}
        </base-button>
        <base-button class="a-button -outline-dark semibold p-4 px-0" @click="exportExcel()">
          {{ $t('exportExcel', 'Eksportér Excel') }}
        </base-button>
      </slot>
      <slot v-if="buttonText" name="button">
        <base-link class="text-decoration-none" :link="buttonLink" style="grid-column: 2">
          <base-button class="-primary p-4 px-0 w-100">
            {{ buttonText }}
          </base-button>
        </base-link>
      </slot>
      <mini-basket-pdf
        class="d-none"
        :print-basket="printBasket"
        :order-summary="summary"
        :order-lines="orderlines"
        :addons="addons"
        @print-basket="resetPrintBasket()"
      />

    </div>
    <div v-if="isDev">
      <button v-on:click="clearBasket">Ryd kurv</button>
    </div>
  </div>
</template>

<script>
import PaymentInformation from '@/components/molecules/ShopCommerce/PaymentInformation'
import BaseLink from '@/components/atoms/BaseLink'
import BaseButton from '@/components/atoms/BaseButton'
import MiniBasketPdf from '@/components/organisms/MiniBasketPDF'

export default {
  name: 'OrderSummary',
  components: {
    PaymentInformation,
    BaseLink,
    BaseButton,
    MiniBasketPdf
  },
  props: {
    summary: {
      default: () => {},
      type: Object
    },
    buttonLink: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    showShippingDelta: {
      type: Boolean,
      default: true
    },
    orderlines: {
      default: () => {},
      type: Array
    },
    addons: {
      default: () => {},
      type: Array
    }
  },
  data() {
    return {
      printBasket: false
    }
  },
  computed: {
    isDev() {
      return process.env.NODE_ENV === 'development'
    },
    includesNonrefundableItems() {
      return this.orderlines?.some(
        (orderline) => orderline?.customProperties?.orderingItem === 'True' || orderline?.customProperties?.restsalgItem === 'True'
      )
    },
    termsAndConditionsPage() {
      return this.$store.getters['site/getSiteSettings']?.termsAndConditionsPage
    },
    basket() {
      return this.$store.getters['cart/basket/getBasket']
    },
    culture() {
      return this.$store.getters['site/getCurrentCulture']
    }
  },
  methods: {
    printPdf() {
      return (this.printBasket = true)
    },
    resetPrintBasket() {
      this.printBasket = false
    },
    exportExcel() {
      window.location.href = this.$repositories.basket.exportExcelUrl(this.culture, this.basket?.guid)
    },
    clearBasket() {
      window.document.cookie = 'basketid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      window.location.reload()
    }
  }
}
</script>
